import { useQuery } from '@tanstack/react-query';
import { getBankOperationsAvailableActions } from 'config/requests/bankOperations';

export const useRequestsBankOpsAvailableActions = (id: number | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: ['bank_operations/available', id],
    queryFn: () => getBankOperationsAvailableActions(id!),
    enabled: Boolean(id),
  });

  return { data, isLoading };
};
